import { QuestionBase } from './question-base';

/*

Sample:

new CheckboxQuestion({
  key: 'enabled',
  label: 'nouns.enabled',
  value: student ? student.enabled : false,
  order: 4
})

*/
export class CheckboxQuestion extends QuestionBase<boolean> {
  controlType = 'checkbox';
  checkedValue: any = true;
  uncheckedValue: any = false;
  big: boolean = false;

  constructor(options: {} = {}) {
    super({ ...options, designSystem: true });
    this.checkedValue = options['checkedValue'] || true;
    this.uncheckedValue = options['uncheckedValue'] || false;
    this.value = options['value'] || false;
    this.big = options['big'];
  }

  isChecked() {
    // sync value with control value
    this.value = this.control ? this.control.value : this.value;
    return this.checkedValue === this.value;
  }

  parseValue(value) {
    if (typeof value === 'boolean' && this.checkedValue) {
      return value ? this.checkedValue : this.uncheckedValue;
    }
    return value;
  }
}
